import AxiosConfig from '../config/axiosConfigApiAgenda'

export const AgendasApi = {

  async getAgenda(request) {
    let response = await AxiosConfig.api().post('agenda/listar-por-curso', request)
    return response.data
  },

  async getScheduleConfig(scheduleId) {
    let response = await AxiosConfig.api().get('agenda/cronograma-config/' + scheduleId)
    return response.data
  },

  async getMateriais() {
    let response = await AxiosConfig.api().get('materiais-estudo')
    return response.data
  },

  async getObjetivos() {
    let response = await AxiosConfig.api().get('objetivos-estudo')
    return response.data
  },

  async listarDisciplinasCursos() {
    let response = await AxiosConfig.api().get('categorias/disciplinas/cursos')
    return response.data
  },

  async create(scheduleConfig) {
    const config = {
      ...scheduleConfig,
      dias_da_semana: '[' + scheduleConfig.dias_da_semana.toString() + ']'
    }

    let response = await AxiosConfig.api().post(`agenda/cadastrar`, config)
    return response.data
  },

  async update(scheduleConfig) {
    const config = {
      ...scheduleConfig,
      dias_da_semana: '[' + scheduleConfig.dias_da_semana.toString() + ']'
    }

    let response = await AxiosConfig.api().post('agenda/atualizar/' + config.id, config)
    return response.data
  },

  async delete(agenda_id) {
    let response = await AxiosConfig.api().post('agenda/deletar', {
      agenda_id
    })
    return response.data
  },

  async getTempoTotalConteudo(agendaConfig) {
    let response = await AxiosConfig.api().post(`agenda/tempo-total-conteudo`, agendaConfig)
    return response.data
  }
}

export default AgendasApi
